import { registerLazyNotificationRenderer } from "@/entities/notification"

registerLazyNotificationRenderer(
	"friend-request",
	() => import("../ui/friend-request-popup"),
)
registerLazyNotificationRenderer(
	"friend-response",
	() => import("../ui/friend-response-popup"),
)
registerLazyNotificationRenderer(
	"friend-accepted",
	() => import("../ui/friend-accepted-popup"),
)
registerLazyNotificationRenderer(
	"friend-rejected",
	() => import("../ui/friend-rejected-popup"),
)
